import React from 'react';
import css from './PackagesBenefitsModal.css';
import { IconCheckCircleL } from '../../icons';

export default ({ isProfilePackageType }) => (
    <>
        <h3 className={css.title}>
            {isProfilePackageType
                ? 'Anonymisiere dein Profil bis zum Match'
                : 'Anonymisiere das Profil bis zum Match'}
        </h3>
        <p className={css.description}>Das Zusatzpaket beinhaltet folgende Leistungen:</p>
        <div className={css.benefitsHolder}>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Dein Name wird für andere Mitglieder anonymisiert, bis Du ihre Anfrage akzeptierst.'
                        : 'Alle Namen werden für andere Mitglieder anonymisiert, bis Du ihre Anfrage akzeptierst.'}
                </p>
            </div>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Fotos und Videos werden für andere Mitglieder verborgen, bis Du ihre Anfrage akzeptierst.'
                        : 'Fotos und Videos werden für andere Mitglieder verborgen, bis Du ihre Anfrage akzeptierst.'}
                </p>
            </div>
            <div className={css.benefitItem}>
                <IconCheckCircleL />{' '}
                <p>
                    {isProfilePackageType
                        ? 'Für mehr Vertrauen: Hebe bei proaktiven Anfragen optional deine Anonymität auf.'
                        : 'Für mehr Vertrauen: Hebe bei proaktiven Anfragen optional deine Anonymität auf.'}
                </p>
            </div>
        </div>
    </>
);
